var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJourney3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aj3{fill:none;}.bj3{fill:#707070;}.cj3{fill:#f7f7f7;}.dj3{fill:#fff;}.ej3{fill:#b30200;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "aj3",
    width: 96,
    height: 96
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-119 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "bj3",
    width: 6,
    height: 6,
    transform: "translate(133.901 31.174)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bj3",
    width: 6,
    height: 6,
    transform: "translate(133.901 39.174)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bj3",
    width: 6,
    height: 6,
    transform: "translate(133.901 47.174)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bj3",
    width: 6,
    height: 6,
    transform: "translate(133.901 55.174)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bj3",
    width: 6,
    height: 6,
    transform: "translate(133.901 63.174)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bj3",
    width: 6,
    height: 6,
    transform: "translate(133.901 71.174)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bj3",
    width: 6,
    height: 6,
    transform: "translate(133.901 79.174)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bj3",
    width: 6,
    height: 6,
    transform: "translate(141.901 31.174)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bj3",
    width: 6,
    height: 6,
    transform: "translate(141.901 39.174)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bj3",
    width: 6,
    height: 6,
    transform: "translate(141.901 47.174)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bj3",
    width: 6,
    height: 6,
    transform: "translate(141.901 55.174)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bj3",
    width: 6,
    height: 6,
    transform: "translate(141.901 63.174)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bj3",
    width: 6,
    height: 6,
    transform: "translate(141.901 71.174)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bj3",
    width: 6,
    height: 6,
    transform: "translate(141.901 79.174)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bj3",
    width: 6,
    height: 6,
    transform: "translate(149.901 31.174)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bj3",
    width: 6,
    height: 6,
    transform: "translate(149.901 39.174)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bj3",
    width: 6,
    height: 6,
    transform: "translate(149.901 47.174)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bj3",
    width: 6,
    height: 6,
    transform: "translate(149.901 55.174)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bj3",
    width: 6,
    height: 6,
    transform: "translate(149.901 63.174)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bj3",
    width: 6,
    height: 6,
    transform: "translate(149.901 71.174)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bj3",
    width: 6,
    height: 6,
    transform: "translate(149.901 79.174)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj3",
    d: "M159,27H131V96h2.9V87.174h6V96h2V87.174h6V96h2V87.174h6V96H159V27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bj3",
    width: 2,
    height: 4,
    transform: "translate(207 96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bj3",
    width: 3,
    height: 4,
    transform: "translate(124 96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cj3",
    width: 20,
    height: 31,
    transform: "translate(163 65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bj3",
    d: "M183,100h24V19H183V61H163V23H127v77h56Zm4-77h16V96H187ZM163,65h20V96H163Zm-7.1,31V87.174h-6V96h-2V87.174h-6V96h-2V87.174h-6V96H131V27h28V96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cj3",
    d: "M207,19h0v81h0V19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cj3",
    d: "M203,96V23H187V96h16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dj3",
    width: 37,
    height: 39,
    transform: "translate(170 36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ej3",
    d: "M211,79H166V32h45Zm-41-4h37V36H170Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ej3",
    d: "M203.5,51.691h-4v-8h-22v8h-4v-12h30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ej3",
    d: "M203.5,71.691h-30v-12h4v8h22v-8h4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ej3",
    width: 4,
    height: 4,
    transform: "translate(199.5 53.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ej3",
    width: 4,
    height: 4,
    transform: "translate(173.5 53)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJourney3);
export default __webpack_public_path__ + "static/media/journey3.1bb268f0b5b70e96f59426cacbf34d13.svg";
export { ForwardRef as ReactComponent };